import router from "@/router";

export default function(to, from, next) {
        window.store.dispatch("Config/loadStoreInfo").then(() => {
                
        }).catch((err)=>{
                //window.location = 'https://testing.localbee.de?msg=this restaurant is not ready yet'
        })
        next();
}